import React, { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { DataTable } from 'components/ui/DataTable';
import { useColumns } from './columns';
import { MainContainer } from 'components/shared';
import { SettingLayout } from 'layouts/SettingLayout';
import { InnerOptions } from '../InnerOptions';
import { useHubDriver } from 'hooks/api';
import { useFilterStore, usePaginationStore } from 'store/hub/hubDriver';
import { useErrorHandler } from 'exceptions/ErrorHandler';
import { HubDeleteDriver } from '../Delete';
import { DataFilter } from './DataFilter';

import { IHubDriver } from 'interfaces/Hub';
import { InHomolog } from 'utils/InHomolog';
export const HubListDriver: React.FC = () => {
  const { options } = InnerOptions();
  const { errorHandler } = useErrorHandler();
  const navigate = useHistory();
  const { filtersData } = useFilterStore();
  const { pagination, setPagination } = usePaginationStore();
  const { getListDrivers } = useHubDriver();
  const [toDelete, setToDelete] = useState<IHubDriver | null>(null);

  const handleDelete = (dataToDelete: IHubDriver) => {
    setToDelete(dataToDelete);
  };

  const { columns } = useColumns({ deleteFunc: handleDelete });

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getListDrivers', filtersData, pagination],
    queryFn: () => getListDrivers(filtersData, pagination),
    onError: errorHandler,
  });

  const onCloseDelete = useCallback(() => {
    setToDelete(() => null);
    refetch();
  }, [refetch]);

  const handlerPageEdit = useCallback(
    (row: any) => {
      navigate.push(`/settings/hub-drivers/edit/${row.original.id}`);
    },
    [navigate]
  );

  return (
    <MainContainer>
      <InHomolog />
      <SettingLayout options={options} page="hub-drivers">
        <DataFilter />
        {toDelete && (
          <HubDeleteDriver
            isOpen={!!toDelete}
            data={toDelete}
            onClose={onCloseDelete}
          />
        )}
        <section>
          <DataTable
            data={data?.drivers ?? []}
            isLoading={isLoading}
            columns={columns}
            manualPagination={true}
            pagination={data?.pagination ?? {}}
            onPaginationChange={setPagination}
            showControlColumns={false}
            onRowClick={(row) => handlerPageEdit(row)}
          />
        </section>
      </SettingLayout>
    </MainContainer>
  );
};
